export default "__VITE_PUBLIC_ASSET__2b78796a__"